import { atom } from "recoil";

export const carePlanTableDataState = atom({
    key: "carePlanTableDataState",
    default: [],
});
